interface ApiConstantsInterface {
  baseUrl: string
  postDynamicPricingByProductAttributes: string
}

const apiConstants: ApiConstantsInterface = {
  baseUrl: '/api/v1',
  postDynamicPricingByProductAttributes: `/product-variant`,
}

export { apiConstants, ApiConstantsInterface }
